import { useAuth0 } from '@auth0/auth0-react'
import { useAppState } from 'Context/AppContext/AppContext'

/*
 * Hook that returns a boolean determining whether to show the app navigation
 */
export const useShowAppNavigation = (): boolean => {
  const { isAuthenticated } = useAuth0()
  const { ui, userConfig, funderOrgConfig } = useAppState()

  // Don’t show the navigation on the login page
  if (!isAuthenticated) {
    return false
  }

  // Individual pages have the ability to hide the navigation by setting this in context
  if (!ui.showNavigation) {
    return false
  }

  // Not sure what this case is, copied from previous navigation
  if (!userConfig.id && !funderOrgConfig?.orgId) {
    return false
  }

  return true
}
